"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrefsFromPartial = exports.DEFAULT_PREFS = exports.Prefs = exports.CO2CalculationMethod = exports.CO2SensorCorrectionBounds = exports.FlowRateCO2Bounds = exports.AbsorptionRateCO2Bounds = exports.PressureCO2Bounds = exports.OnOffTimer = exports.Timer = exports.HourMinuteTuple = exports.SleepMode = exports.SLEEP_MODES = exports.FanSpeedOption = exports.FanSpeed = exports.FAN_SPEED_VALUES = exports.ChilledTemperatureSetPointBounds = exports.BoilingTemperatureSetPointBounds = exports.MaxDispenseTimeBounds = exports.TimezoneFromTimezoneName = exports.TIMEZONE_NAMES = exports.SystemOfUnits = exports.Language = void 0;
const effect_1 = require("effect");
const schema_1 = require("../../../../schema");
const time_1 = require("../../../../time");
const Timezone = __importStar(require("../../../../timezone"));
const Unit = __importStar(require("../../../../unit"));
const NAMESPACE = 'Culligan.Device.Class.HydroTapBridge.Prefs';
exports.Language = effect_1.Schema.transformLiterals(['en-GB', 'English (United Kingdom)'], ['en-US', 'English (United States)'], ['de-DE', 'German'], ['fr-FR', 'French'], ['zh-CN', 'Chinese']).annotations({
    identifier: `${NAMESPACE}.Language`,
});
exports.SystemOfUnits = effect_1.Schema.transformLiterals(...[
    ['SI', 'International System of Units (SI)'],
    ['IMPERIAL', 'Imperial units'],
    ['US', 'United States customary units'],
]).annotations({ identifier: `${NAMESPACE}.SystemOfUnits` });
exports.TIMEZONE_NAMES = [
    // Oceania
    'Australia/Sydney',
    'Australia/Brisbane',
    'Australia/Adelaide',
    'Australia/Perth',
    'Pacific/Auckland',
    // Europe
    'Europe/London',
    'Europe/Paris',
    'Europe/Berlin',
    // South East Asia
    'Asia/Shanghai',
    'Asia/Singapore',
    'Asia/Hong_Kong',
    'Asia/Kuala_Lumpur',
    'Asia/Manila',
    'Asia/Jakarta',
    'Asia/Makassar',
    'Asia/Jayapura',
    'Asia/Kolkata',
    // Middle East
    'Asia/Dubai',
    'Asia/Riyadh',
    'Asia/Jerusalem',
    // Africa
    'Africa/Johannesburg',
    // North America
    'America/New_York',
    'America/Chicago',
    'America/Denver',
    'America/Los_Angeles',
    'America/Phoenix',
    // South America
    'America/Sao_Paulo',
    'America/Argentina/Buenos_Aires',
    'America/Santiago',
    'America/Bogota',
    'America/Lima',
];
exports.TimezoneFromTimezoneName = Timezone.makeTimezoneFromTimezoneName(exports.TIMEZONE_NAMES).annotations({ identifier: `${NAMESPACE}.TimezoneFromTimezoneName` });
exports.MaxDispenseTimeBounds = { min: 5, max: 15 };
const MaxDispenseTime = effect_1.Schema.Int.pipe(effect_1.Schema.between(exports.MaxDispenseTimeBounds.min, exports.MaxDispenseTimeBounds.max), Unit.Into(Unit.Time.Second)).annotations({
    identifier: `${NAMESPACE}.MaxDispenseTime`,
    description: 'Maximum continuous dispense duration',
});
exports.BoilingTemperatureSetPointBounds = { min: 64, max: 100 };
const BoilingTemperatureSetPoint = effect_1.Schema.Number.pipe(effect_1.Schema.between(exports.BoilingTemperatureSetPointBounds.min, exports.BoilingTemperatureSetPointBounds.max), Unit.Into(Unit.Temperature.Celsius)).annotations({
    identifier: `${NAMESPACE}.BoilingTemperatureSetPoint`,
});
exports.ChilledTemperatureSetPointBounds = { min: 5, max: 9 };
const ChilledTemperatureSetPoint = effect_1.Schema.Int.pipe(effect_1.Schema.between(exports.ChilledTemperatureSetPointBounds.min, exports.ChilledTemperatureSetPointBounds.max), Unit.Into(Unit.Temperature.Celsius)).annotations({
    identifier: `${NAMESPACE}.ChilledTemperatureSetPoint`,
    documentation: '6 - 9 °C for residential, 5 - 9 °C for commercial',
});
exports.FAN_SPEED_VALUES = [75, 100];
exports.FanSpeed = effect_1.Schema.Literal(...exports.FAN_SPEED_VALUES)
    .pipe(Unit.Into(Unit.Compound.Percentage))
    .annotations({ identifier: `${NAMESPACE}.FanSpeed` });
exports.FanSpeedOption = effect_1.Schema.OptionFromNullOr(exports.FanSpeed).annotations({
    identifier: `${NAMESPACE}.FanSpeedOption`,
});
exports.SLEEP_MODES = [
    [1, 'TimedEco'],
    [2, 'TimedKill'],
    [3, 'DarkEco'],
    [4, 'DarkKill'],
    [5, 'EitherEco'],
    [6, 'EitherKill'],
];
exports.SleepMode = (0, schema_1.OptionFromZeroOr)(effect_1.Schema.transformLiterals(...exports.SLEEP_MODES)).annotations({
    identifier: `${NAMESPACE}.SleepMode`,
    description: 'A number which represents one of 6 energy saving modes based on usage and ambient light',
    documentation: `\
0=disabled
1=2hr->hot side to 68 °C
2=2hr->off
3=darkness->hot side to 68 °C
4=darkness->off
5=darkness or 2hr->hot side to 68 °C
6=darkness or 2hr->off`,
});
exports.HourMinuteTuple = effect_1.Schema.Tuple(effect_1.Schema.Int.pipe(effect_1.Schema.between(0, 23)), effect_1.Schema.Int.pipe(effect_1.Schema.between(0, 59))).annotations({ identifier: `${NAMESPACE}.HourMinuteTuple` });
exports.Timer = effect_1.Schema.Struct({
    on: effect_1.Schema.NullOr(exports.HourMinuteTuple),
    off: effect_1.Schema.NullOr(exports.HourMinuteTuple),
}).annotations({ identifier: `${NAMESPACE}.Timer` });
exports.OnOffTimer = effect_1.Schema.Tuple(exports.Timer, // Monday
exports.Timer, // Tuesday
exports.Timer, // Wednesday
exports.Timer, // Thursday
exports.Timer, // Friday
exports.Timer, // Saturday
exports.Timer).annotations({ identifier: `${NAMESPACE}.OnOffTimer` });
exports.PressureCO2Bounds = { min: 10, max: 50 };
const PressureCO2 = effect_1.Schema.Int.pipe(effect_1.Schema.between(exports.PressureCO2Bounds.min, exports.PressureCO2Bounds.max), Unit.Into(Unit.Pressure.Decibar)).annotations({
    identifier: `${NAMESPACE}.PressureCO2`,
});
exports.AbsorptionRateCO2Bounds = { min: 100, max: 1_265 };
const AbsorptionRateCO2 = effect_1.Schema.Int.pipe(effect_1.Schema.between(exports.AbsorptionRateCO2Bounds.min, exports.AbsorptionRateCO2Bounds.max), Unit.Into(Unit.Mass.Gram)).annotations({
    identifier: `${NAMESPACE}.AbsorptionRateCO2`,
});
exports.FlowRateCO2Bounds = { min: 100, max: 800 };
const FlowRateCO2 = effect_1.Schema.Int.pipe(effect_1.Schema.between(exports.FlowRateCO2Bounds.min, exports.FlowRateCO2Bounds.max), Unit.Into(Unit.Volume.Milliliter)).annotations({
    identifier: `${NAMESPACE}.FlowRateCO2`,
});
exports.CO2SensorCorrectionBounds = { min: -100, max: 100 };
const CO2SensorCorrection = effect_1.Schema.Int.pipe(effect_1.Schema.between(exports.CO2SensorCorrectionBounds.min, exports.CO2SensorCorrectionBounds.max), Unit.Into(Unit.Compound.SignedPercentage)).annotations({
    identifier: `${NAMESPACE}.CO2SensorCorrection`,
});
exports.CO2CalculationMethod = effect_1.Schema.transformLiterals(['sensor', 'CO₂ sensor'], ['solenoidTimings', 'Solenoid timings'], ['auto', 'Auto']).annotations({
    identifier: `${NAMESPACE}.CO2CalculationMethod`,
});
exports.Prefs = effect_1.Schema.Struct({
    language: effect_1.Schema.propertySignature(exports.Language).annotations({
        title: 'Language',
        description: 'The language confirmed for the command center user interface',
    }),
    timezone: effect_1.Schema.propertySignature(exports.TimezoneFromTimezoneName).annotations({
        title: 'Timezone',
        description: 'The timezone configured on the device',
    }),
    systemOfUnits: effect_1.Schema.propertySignature(exports.SystemOfUnits).annotations({
        title: 'System of units',
        description: 'The system of units used by the device to format measurements',
    }),
    dispenseTimeBoiling: effect_1.Schema.propertySignature(MaxDispenseTime).annotations({
        title: 'Boiling maximum dispense time',
        description: 'The amount of seconds after which an ongoing boiling dispense is automatically stopped',
    }),
    dispenseTimeChilled: effect_1.Schema.propertySignature(MaxDispenseTime).annotations({
        title: 'Chilled maximum dispense time',
        description: 'The amount of seconds after which an ongoing chilled dispense is automatically stopped',
    }),
    dispenseTimeSparkling: effect_1.Schema.propertySignature(MaxDispenseTime).annotations({
        title: 'Sparkling maximum dispense time',
        description: 'The amount of seconds after which an ongoing sparkling dispense is automatically stopped',
    }),
    setPointTemperatureBoiling: effect_1.Schema.propertySignature(BoilingTemperatureSetPoint).annotations({
        title: 'Boiling temperature set point',
        description: 'Target temperature for boiling water in °C',
    }),
    setPointTemperatureChilled: effect_1.Schema.propertySignature(ChilledTemperatureSetPoint).annotations({
        title: 'Chilled temperature set point',
        description: 'Target temperature for chilled water in °C',
    }),
    fanSpeed: effect_1.Schema.propertySignature(exports.FanSpeedOption).annotations({
        title: 'Fan speed control',
        description: 'The speed the fan should run at. Send null for Auto to let the device regulate its own fan speed.',
    }),
    sleepModeSetting: effect_1.Schema.propertySignature(exports.SleepMode).annotations({
        title: 'Sleep mode',
        description: 'The sleep mode setting to be used',
    }),
    safetyLock: effect_1.Schema.propertySignature(effect_1.Schema.Boolean).annotations({
        title: 'Safety lock',
        description: 'Whether the boiling water safety lock is enabled',
    }),
    onOffTimer: effect_1.Schema.propertySignature(exports.OnOffTimer).annotations({
        title: 'On/off timer',
        description: 'The time schedule the unit will use to automatically turn on and off',
    }),
    co2Pressure: effect_1.Schema.propertySignature(PressureCO2).annotations({
        title: 'CO₂ pressure',
        description: 'The pressure of the CO₂ tank',
    }),
    co2AbsorptionRate: effect_1.Schema.propertySignature(AbsorptionRateCO2).annotations({
        title: 'CO₂ absorption rate',
        description: 'Expressed in grams per liter',
    }),
    co2FlowRate: effect_1.Schema.propertySignature(FlowRateCO2).annotations({
        title: 'CO₂ flow rate',
        description: 'Expressed in milliliters per 15 seconds',
    }),
    co2SensorCorrection: effect_1.Schema.propertySignature(CO2SensorCorrection).annotations({
        title: 'CO₂ sensor correction',
        description: 'Adjusts the CO₂ sensor measurement by this percentage',
    }),
    co2CalculationMethod: effect_1.Schema.propertySignature(exports.CO2CalculationMethod).annotations({
        title: 'CO₂ calculation method',
        description: 'How CO₂ usage is calculated: from the CO₂ sensor, from the sparkling solenoid timings, ' +
            'or automatically (the sensor if present, otherwise the solenoid timings)',
    }),
    betaFirmwareEnabled: effect_1.Schema.propertySignature(effect_1.Schema.Boolean).annotations({
        title: 'Beta firmware enabled',
        description: 'Whether this device is opted into receiving beta firmware updates',
    }),
    autoFirmwareUpdates: effect_1.Schema.propertySignature(effect_1.Schema.Boolean).annotations({
        title: 'Automatic firmware updates',
        description: 'Whether the device checks daily for firmware updates to any of its memory regions and, ' +
            'when it finds them, sequences the OTA updates itself',
    }),
    telemetryInterval: effect_1.Schema.propertySignature(time_1.DurationFromSeconds).annotations({
        title: 'Telemetry interval',
        description: 'The frequency at which telemetry messages should be sent',
    }),
    stateInterval: effect_1.Schema.propertySignature(time_1.DurationFromSeconds).annotations({
        title: 'State interval',
        description: 'The frequency at which state messages should be sent',
    }),
    consumableInterval: effect_1.Schema.propertySignature(time_1.DurationFromSeconds).annotations({
        title: 'Consumable interval',
        description: 'The frequency at which consumable messages should be sent',
    }),
}).annotations({
    identifier: `${NAMESPACE}.Prefs`,
    documentation: 'https://zipindustries.sharepoint.com/:x:/r/sites/NPDTeam-InnovationProjects/Shared%20Documents/Innovation%20Projects/Everest/For%20Sharing%20-%20Bob/Zip_DataPoints_Culligan.xlsx?d=w203a5c7cc0ca4051885928f6c9e72d79&csf=1&web=1&e=RuKzNt',
});
exports.DEFAULT_PREFS = {
    language: 'English (United Kingdom)',
    timezone: effect_1.Schema.decodeSync(exports.TimezoneFromTimezoneName)('Australia/Sydney'),
    systemOfUnits: 'International System of Units (SI)',
    dispenseTimeBoiling: Unit.Time.Second.make({ amount: 15 }),
    dispenseTimeChilled: Unit.Time.Second.make({ amount: 15 }),
    dispenseTimeSparkling: Unit.Time.Second.make({ amount: 15 }),
    setPointTemperatureBoiling: Unit.Temperature.Celsius.make({ amount: 98 }),
    setPointTemperatureChilled: Unit.Temperature.Celsius.make({ amount: 5 }),
    fanSpeed: effect_1.Option.none(),
    sleepModeSetting: effect_1.Option.none(),
    safetyLock: true,
    onOffTimer: [
        { on: [7, 0], off: null },
        { on: [7, 0], off: null },
        { on: [7, 0], off: null },
        { on: [7, 0], off: null },
        { on: [7, 0], off: null },
        { on: [7, 0], off: null },
        { on: [7, 0], off: null },
    ],
    co2Pressure: Unit.Pressure.Decibar.make({ amount: 30 }),
    co2AbsorptionRate: Unit.Mass.Gram.make({ amount: 565 }),
    co2FlowRate: Unit.Volume.Milliliter.make({ amount: 400 }),
    co2SensorCorrection: Unit.Compound.SignedPercentage.make({ amount: 5 }),
    co2CalculationMethod: 'Auto',
    betaFirmwareEnabled: false,
    autoFirmwareUpdates: false,
    telemetryInterval: effect_1.Duration.minutes(10),
    stateInterval: effect_1.Duration.hours(24),
    consumableInterval: effect_1.Duration.hours(4),
};
exports.PrefsFromPartial = (0, schema_1.StructFromPartial)(exports.DEFAULT_PREFS)(exports.Prefs).annotations({
    identifier: `${NAMESPACE}.PrefsFromPartial`,
});
//# sourceMappingURL=prefs.js.map